import PrivateRoute from "./PrivateRoute";

interface IRouteWrapper {
  component: any;
  layout: any;
  path: string;
  exact?: boolean;
  roles?: string[];
}

export default function RouteWrapper({
  component: Component, 
  layout: Layout,
  path,
  exact,
  roles,
  ...rest
}: IRouteWrapper) {
  return (
    <PrivateRoute exact={exact} path={path} roles={roles} render={(props) =>
      <Layout>
        <Component {...props} />
      </Layout>
    } />
  );
}